module.exports = __webpack_public_path__ + "static/media/logo-01.28750019.svg";